import React from 'react';

import logo from '../../assets/optimized/logo-96.png';
import '../../assets/styles/PageLoader.css';

function PageLoader({ minHeight = 420 }) {
  return (
    <div className="site-page-loader" style={{ minHeight }} role="status" aria-label="Yuklanmoqda">
      <div className="site-page-loader-mark">
        <img src={logo} alt="" width="96" height="96" />
      </div>
    </div>
  );
}

export default PageLoader;
